<template>
    <span>
        <span v-if="isFailure == false" :class="className">{{showName}}</span>
        <span style="color:#5babfb;cursor: pointer;" v-if="isFailure == true" :class="className" @click="Failure">{{showName}}</span>
    </span>
</template>
<script>
import { getDictData } from "@/api/keyValue/keyValue";
import { setStore, getStore } from "@/utils/store";
export default {
    props: {
        // 绑定值
        value : {

        },
        // 默认的参数
        defaultValue: {
            type: String,
            default: "/"
        },
        // 字典请求url
        dictUrl : {
            type: String
        },
        // 数据映射关系
        dictProp : {
            type: Object,
            default : function () {
                return {
                    data: "result",
                    label: "dictValue",
                    value: "dictKey"
                }
            }
        },
        // class name
        className: {
            type: String,
            default: ""
        },
        //C7特殊查看失败弹框
        isFailure:{
          type:Boolean,
          default:false
        },
        // 请求方式
        methods: {
            type: String,
            default: "get"
        },
        // 默认搜索 传入后台参数
        searchParam: {
            type: String,
            default: "deptName"
        },
        needSearch: {
            type: Boolean,
            default:false
        }
    },
    watch: {
        value() {
            // console.log(this.currentValue)
            if (!this.value && this.value !== 0) {
                this.showName = ''
            } else if (this.currentValue !== this.value) {
                this.currentValue = this.value
                this.getDictDataAction(this.dictUrl)
            }
        }
    },
    data () {
        return {
            showName: "",
            dictType: undefined,
            currentValue: '',
        }
    },
    created () {
        if (!this.value && this.value !== 0) {
            this.showName = ''
        } else {
            // console.log(this.value)
            this.currentValue = this.value
            this.getDictDataAction(this.dictUrl)
        }
        // console.log("value" + this.value)
    },
    methods: {
        loadToView(dictUrl, dictData){
            let result = getStore({name:dictUrl+this.value, type:'session'})
            // console.log(dictUrl+this.value)
            if (result != undefined && result.time > new Date().getTime()) {
                // console.log(result.data, '2222')
                this.showName = result.data
            } else {
                let tempShow = ""
                if (dictData.length > 0){
                    if(this.dictType == undefined){
                        this.dictType = typeof dictData[0]["value"]
                    }
                    if (this.dictType !== (typeof this.currentValue)){
                        switch (this.dictType){
                            case 'string' : {
                                this.currentValue = this.value.toString()
                            }
                            break;
                            case 'number' : {
                                let aTemp = parseInt(this.currentValue)
                                this.currentValue =  isNaN(aTemp) ? 'def' : aTemp
                            }
                        }
                    }
                }

                for (let index in dictData){
                    let item = dictData[index]
                    if (item.value == this.value){
                        tempShow = item.label
                    }
                }
                result = {}
                result.data = tempShow
                result.time = new Date().getTime() + 5*60*1000
                setStore({
                    name: dictUrl+this.value,
                    content: result,
                    type: 'session'
                })
                this.showName = result.data
            }
            // console.log(this.showName, '333333')
        },
        async getDictDataAction(dictUrl){
            let result = getStore({name:dictUrl, type:'session'})
            if (result != undefined && result.time > new Date().getTime()) {
                this.loadToView(dictUrl, result.data)
                // console.log(result.data)
            } else {
                let requestParma = {
                    tenantId: this.$store.state.user.tenantId
                }
                let dictData
                if (this.needSearch) {
                    let requestParma = {
                    tenantId: this.$store.state.user.tenantId
                    // tenantId: '000000'
                    };
                    requestParma[this.searchParam] = this.currentValue;
                    dictData = await getDictData(dictUrl, true, requestParma, this.methods)
                } else {
                    dictData = await getDictData(
                        dictUrl,
                        false,
                        Object.assign(requestParma, this.searchParam),
                        this.methods,
                    )
                } 
                let realData = []
                if (this.getResultIsReady(dictData,this.dictProp.data) != undefined){
                    let temp = this.getResultIsReady(dictData,this.dictProp.data)
                    for (let index in temp){
                        let item = temp[index]
                        realData.push({
                            label : item[this.dictProp.label],
                            value : item[this.dictProp.value]
                        })
                    }
                }
                result = {}
                result.data = realData
                result.time = new Date().getTime() + 5*60*1000
                setStore({
                    name: dictUrl,
                    content: result,
                    type: 'session'
                })
                this.loadToView(dictUrl, result.data)
            }
            // console.log(result)
        },
        getResultIsReady(dictData,dataProp){
            let resultDir = dataProp.split('.');
            let temp = dictData
            resultDir.forEach(element => {
                if(temp[element] !== undefined){
                    temp = temp[element]
                }
            });
            if (temp !== undefined) {
                return temp
            }
        },
        Failure(){
           this.$emit("IsFailure");
        }
    }
}
</script>
